import { Locale } from '@/types/locale';

const mapped = {
  en: 'en-US',
  es: 'es-MX',
  pt: 'pt-BR',
};

export const numbersLocale = (locale: Locale): string => mapped[locale] ?? 'en-US';
